import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, FormControlLabel, Radio } from '@metarouter-private/mr-mui';

export default function UpdateModeOption({ value, title, description }) {
  return (
    <FormControlLabel
      value={value}
      control={<Radio />}
      label={
        <Stack spacing={0.5}>
          <Typography variant="body2" fontWeight="medium">
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      }
    />
  );
}

UpdateModeOption.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
